import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { CreateEmergencyInfoComponent } from './create-emergency-info/create-emergency-info.component';
import { ViewEmergencyInfoComponent } from './view-emergency-info/view-emergency-info.component';
import { UpdateEmergencyInfoComponent } from './update-emergency-info/update-emergency-info.component';
// import { CKEditorValueAccessorDirective } from './create-emergency-info/ckeditor-value-accessor.component';


const routes: Routes = [
  { path: '', component: CreateEmergencyInfoComponent },
  { path: 'create-emergency-info', component: CreateEmergencyInfoComponent },
  { path: 'view-emergency-info', component: ViewEmergencyInfoComponent },
  { path: 'update-emergency-info', component: UpdateEmergencyInfoComponent },
];


@NgModule({
  declarations: [
    CreateEmergencyInfoComponent,
    ViewEmergencyInfoComponent,
    UpdateEmergencyInfoComponent,
    // CKEditorValueAccessorDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    AutocompleteLibModule,
    NgSelectModule,
    CKEditorModule
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class EmergencyinfoModule { }
